import HeaderContainer from './HeaderContainer.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(
      config,
      'headerContainer',
      HeaderContainer
    );
  },
};
